import { Loader } from '@mantine/core';
import { theme } from '../globalStyle/global-styles';
import { CustomButtonWrapper } from './styles';

interface IProps {
  label: string;
  statusColor: 'success' | 'warning' | 'redFlag' | 'info' | string;
  type: 'button' | 'submit' | 'reset';
  icon?: JSX.Element;
  fullWidth?: boolean;
  fontSize?: string;
  fontFamily?: string;
  BGColor?: string;
  iconDirection?: string;
  justify?: string;
  borderColor: 'success' | 'warning' | 'redFlag' | string;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}
export function CustomButton(props: IProps) {
  const {
    label,
    statusColor,
    type = 'button',
    icon,
    fullWidth = false,
    fontSize = '12px',
    fontFamily = `${theme.fonts.Regular}`,
    BGColor = 'transparent',
    borderColor,
    iconDirection = 'row',
    justify = 'center',
    onClick,
    disabled = false,
    isLoading = false,
  } = props;
  return (
    <CustomButtonWrapper
      type={type}
      statusColor={statusColor}
      fullWidth={fullWidth}
      fontSize={fontSize}
      fontFamily={fontFamily}
      BGColor={BGColor}
      borderColor={borderColor}
      iconDirection={iconDirection}
      justify={justify}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="icon">{icon}</span>}
      {isLoading && (
        <span>
          <Loader color="#666666"  size={'xs'} />
        </span>
      )}
      {!isLoading && <span>{label}</span>}
    </CustomButtonWrapper>
  );
}
